import React, { useState } from "react";
import { useField } from "formik";

import styled from "@emotion/styled";
import Switch from "../Switch"
import TimePicker from "../TimePicker"

const WorkingHoursBlock = (props) => {
  const { day, name , disabled, label} = props;

  // get the day value to make the time picker disabled or not based on the day value
  const [field] = useField(`${name}.${day}`);
  const { value } = field;

  const [disable, setDisabled] = useState(!value);

  return (
    <WorkingHoursBlockContainer>
      <label style={{width: '110px', marginRight: '65px'}}>{label}</label>
      <Switch
        disabled={disabled}
        setDisabled={setDisabled}
        // subLabel={day.slice(0, 3)}
        name={`${name}.${day}`}
        
      />

      <TimePicker disabled={ disabled ? disabled : !value} name={`${name}.${day}F`} />

      <TimePicker  disabled={ disabled ? disabled : !value} name={`${name}.${day}T`} />
    </WorkingHoursBlockContainer>
  );
};

const WorkingHoursBlockContainer = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 13px;
  & > * {
    margin: 0 8px;
  }
`;

export default WorkingHoursBlock;
